import { LLM } from '@/types'
import i18next from 'i18next'

import { CATEGORIES } from '../categories'

const GROQ_PLATORM_LINK = 'https://console.groq.com/docs/models'

// Groq Models (UPDATED 09/30/26) -----------------------------
// Mixtral 8x7B and Llama 3 8B/70B are deprecated on Groq — omitted from
// the exported picker list (IDs remain in types for old chats).

const GPT_OSS_120B: LLM = {
  modelId: 'openai/gpt-oss-120b',
  modelName: 'GPT OSS 120B',
  provider: 'groq',
  hostedId: 'openai/gpt-oss-120b',
  platformLink: GROQ_PLATORM_LINK,
  imageInput: false,
  tools: true,
  new: true,
  tier: 'pro',
  supportsStreaming: true,
  description: () =>
    i18next.t(
      'models.providers.groq.gpt_oss_120b.description',
      'OpenAI GPT-OSS 120B on Groq — fast open-weight model with tool calling.'
    ),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 0.15,
    outputCost: 0.6
  },
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.REASONING
  ]
}

const GPT_OSS_20B: LLM = {
  modelId: 'openai/gpt-oss-20b',
  modelName: 'GPT OSS 20B',
  provider: 'groq',
  hostedId: 'openai/gpt-oss-20b',
  platformLink: GROQ_PLATORM_LINK,
  imageInput: false,
  tools: true,
  new: true,
  tier: 'free',
  supportsStreaming: true,
  description: () =>
    i18next.t(
      'models.providers.groq.gpt_oss_20b.description',
      'OpenAI GPT-OSS 20B on Groq — high-throughput, cost-efficient open-weight model.'
    ),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 0.075,
    outputCost: 0.3
  },
  categories: [CATEGORIES.TECHNOLOGY, CATEGORIES.SCIENCE, CATEGORIES.PROGRAMMING]
}

const QWEN_3_6_27B: LLM = {
  modelId: 'qwen/qwen3.6-27b',
  modelName: 'Qwen3.6 27B',
  provider: 'groq',
  hostedId: 'qwen/qwen3.6-27b',
  platformLink: GROQ_PLATORM_LINK,
  imageInput: false,
  tools: true,
  new: true,
  tier: 'pro',
  supportsStreaming: true,
  description: () =>
    i18next.t(
      'models.providers.groq.qwen3_6_27b.description',
      'Qwen3.6 27B on Groq — strong coding and agentic tool use.'
    ),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 0.6,
    outputCost: 3
  },
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.REASONING
  ]
}

export const GROQ_LLM_LIST: LLM[] = [GPT_OSS_120B, GPT_OSS_20B, QWEN_3_6_27B]
